import React, { useState } from 'react';
import { Calendar, ArrowUpDown, MoreHorizontal, MessageCircle } from 'lucide-react';

const PostMenu = () => (
  <div className="absolute top-8 left-0 bg-white border rounded-lg shadow-lg w-48 z-10">
    <ul className="text-sm text-gray-700">
      <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">حذف</li>
      <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">حظر المستخدم</li>
      <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">اضافة رد</li>
      <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">نسخ محتوى السؤال</li>
    </ul>
  </div>
);

const Post = ({ post }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-4 mb-4">
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-3">
          <img src={post.author.avatar} alt={post.author.name} className="w-10 h-10 rounded-full" />
          <div>
            <p className="font-semibold text-gray-800">{post.author.name}</p>
            <p className="text-xs text-gray-500">{post.time}</p>
          </div>
        </div>
        <div className="relative">
          <button onClick={() => setMenuOpen(!menuOpen)} className="text-gray-500 hover:text-gray-700">
            <MoreHorizontal size={20} />
          </button>
          {menuOpen && <PostMenu />}
        </div>
      </div>
      <p className="my-4 text-gray-700">{post.content}</p>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-1 bg-gray-100 rounded-full px-2 py-1 text-sm">
            <span>👍</span>
            <span>{post.reactions.likes}</span>
          </div>
          <div className="flex items-center gap-1 bg-gray-100 rounded-full px-2 py-1 text-sm">
            <span>🤔</span>
            <span>{post.reactions.thinks}</span>
          </div>
          <div className="flex items-center gap-1 bg-gray-100 rounded-full px-2 py-1 text-sm">
            <span>❤️</span>
            <span>{post.reactions.hearts}</span>
          </div>
           <div className="flex items-center gap-1 bg-gray-100 rounded-full px-2 py-1 text-sm">
            <span>😊</span>
            <span>{post.reactions.smiles}</span>
          </div>
        </div>
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <MessageCircle size={16} />
          <span>{post.comments.length} تعليقات</span>
        </div>
      </div>
      {post.comments.length > 0 && (
        <div className="mt-4 pt-4 border-t border-gray-100">
          {post.comments.map(comment => (
            <div key={comment.id} className="flex items-start gap-3 mt-3">
              <img src={comment.author.avatar} alt={comment.author.name} className="w-8 h-8 rounded-full" />
              <div className="flex-1">
                <div className="bg-gray-50 rounded-lg p-3">
                    <p className="font-semibold text-sm text-gray-800">{comment.author.name}</p>
                    <p className="text-sm text-gray-600">{comment.content}</p>
                </div>
                <div className="flex items-center gap-4 text-xs text-gray-500 mt-1 px-2">
                    <button className="hover:underline">أعجبني</button>
                    <button className="hover:underline">أضف رد</button>
                    <span>منذ 3 دقائق</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};


const CommunityPage = () => {
  const posts = [
    {
      id: 1,
      author: { name: 'عادل الخالد', avatar: 'https://ui-avatars.com/api/?background=random&name=Adel+Khaled' },
      time: 'اليوم 11:23 م',
      content: 'هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف.',
      reactions: { likes: 60, thinks: 11, hearts: 34, smiles: 22 },
      comments: [
        {
          id: 1,
          author: { name: 'عادل الخالد', avatar: 'https://ui-avatars.com/api/?background=random&name=Adel+Khaled' },
          content: 'هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة.',
        },
        {
          id: 2,
          author: { name: 'عادل الخالد', avatar: 'https://ui-avatars.com/api/?background=random&name=Adel+Khaled' },
          content: 'هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى.',
        }
      ],
    },
    {
      id: 2,
      author: { name: 'محمود سعيد', avatar: 'https://ui-avatars.com/api/?background=random&name=Mahmoud+Said' },
      time: 'أمس 08:15 ص',
      content: 'هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف.',
      reactions: { likes: 15, thinks: 2, hearts: 5, smiles: 8 },
      comments: [],
    },
  ];

  return (
    <div className="p-4 md:p-6 bg-gray-50 min-h-screen" dir="rtl">
      <h1 className="text-xl md:text-2xl font-bold text-[#1D2035] mb-6">إدارة المجتمع</h1>

      <div className="bg-white rounded-xl border border-gray-200 p-4 mb-6">
        <textarea
          className="w-full p-3 border border-gray-200 rounded-lg focus:ring-red-500 focus:border-red-500"
          rows="3"
          placeholder="أضف سؤالك في المجتمع"
        ></textarea>
        <div className="flex items-center justify-between mt-4">
          <div className="flex items-center gap-4">
            <button className="flex items-center gap-2 px-4 py-2 border rounded-lg text-sm">
              <Calendar size={16} />
              <span>يناير 2025 - يونيو 2025</span>
            </button>
            <button className="flex items-center gap-2 px-4 py-2 border rounded-lg text-sm">
              <ArrowUpDown size={16} />
              <span>من الاحدث الى الاقدم</span>
            </button>
          </div>
          <button className="px-8 py-2.5 bg-[var(--Primary-Primary)] text-white rounded-lg font-semibold shadow-sm hover:bg-red-700 transition-colors">
            نشر
          </button>
        </div>
      </div>

      <div>
        <h2 className="font-semibold text-lg text-gray-800 mb-4">محتوى المجتمع</h2>
        {posts.map(post => (
          <Post key={post.id} post={post} />
        ))}
      </div>
    </div>
  );
};

export default CommunityPage;
